import { unit } from '@othrworld/units';
import { isOrbitHyperbola } from '../orbit';
import { multVector, unitVector } from '../coords';
import { applySpeedChange, findSpeedDiffAtApoapsisForCircular, findSpeedDiffAtPeriapsisForApoapsis, } from '../orbit-change';
import { getNextApoapsisPassage, getNextPeriapsisPassage } from '../passage';
import { getSpeedVector } from '../speed';
export const getHohmannTransfer = (orbit, endRadius, t) => {
    const speedPeri = findSpeedDiffAtPeriapsisForApoapsis(orbit, endRadius);
    const epochPeri = getNextPeriapsisPassage(orbit, t);
    const speedVecUnit = unitVector(getSpeedVector(orbit, epochPeri));
    const periManeuver = {
        epoch: epochPeri,
        deltaV: multVector(speedVecUnit, speedPeri),
    };
    const transferOrbit = applySpeedChange(orbit, epochPeri, {
        prograde: speedPeri,
        normal: unit(0),
    });
    if (isOrbitHyperbola(transferOrbit)) {
        console.error('transferOrbit', Object.assign({}, transferOrbit));
        throw new Error('Transfer orbit is hyperbolic');
    }
    const speedApo = findSpeedDiffAtApoapsisForCircular(transferOrbit);
    const epochApo = getNextApoapsisPassage(transferOrbit, epochPeri);
    const speedApoVecUnit = unitVector(getSpeedVector(transferOrbit, epochApo));
    const apoManeuver = {
        epoch: epochApo,
        deltaV: multVector(speedApoVecUnit, speedApo),
    };
    return [periManeuver, apoManeuver];
};
//# sourceMappingURL=hohmann.js.map